import { Star, Trophy, Quote, PlayCircle, ExternalLink, GraduationCap } from "lucide-react";
import { cn } from "@/lib/utils";

export const TestimonialCard = ({ item }) => {
  const featured = !!item.featured;
  return (
    <div data-testid="testimonial-card" className={cn("relative flex flex-col overflow-hidden rounded-xl border bg-card", featured ? "border-[hsl(var(--brand-red))]" : "border-border")}>
      {featured && (
        <span className="absolute right-3 top-3 z-10 inline-flex items-center gap-1 rounded-full bg-brand px-2.5 py-1 text-[11px] font-bold uppercase tracking-wide text-white"><Star className="h-3 w-3" /> Featured</span>
      )}
      {item.image_url && (
        <div className="relative h-56 overflow-hidden">
          <img src={item.image_url} alt={item.name} loading="lazy" className="h-full w-full object-cover" />
          <div className="absolute inset-0 bg-gradient-to-t from-black/85 via-black/25 to-transparent" />
          {item.video_url && (
            <a href={item.video_url} target="_blank" rel="noopener noreferrer" data-testid="testimonial-video" className="absolute inset-0 flex items-center justify-center text-white/90 transition-transform hover:scale-110">
              <PlayCircle className="h-14 w-14" />
            </a>
          )}
          <div className="absolute bottom-3 left-4 right-4">
            <h3 className="display-title text-2xl text-white">{item.name}</h3>
            <p className="text-xs font-medium uppercase tracking-wide text-white/80">
              {[item.sport, item.school_team].filter(Boolean).join(" \u00b7 ") || item.role}
            </p>
          </div>
        </div>
      )}

      <div className="flex flex-1 flex-col p-6">
        {item.result && (
          <div className="mb-3 inline-flex items-center gap-2 self-start rounded-md bg-brand/10 px-3 py-1.5 text-sm font-semibold text-brand" data-testid="testimonial-result">
            <Trophy className="h-4 w-4" />{item.result}
          </div>
        )}
        {item.rating > 0 && (
          <div className="mb-2 flex gap-0.5">
            {Array.from({ length: item.rating }).map((_, i) => (
              // eslint-disable-next-line react/no-array-index-key
              <Star key={i} className="h-4 w-4 fill-[hsl(var(--brand-red))] text-[hsl(var(--brand-red))]" />
            ))}
          </div>
        )}
        <Quote className="h-5 w-5 text-brand" />
        <p className="mt-1 flex-1 text-sm leading-relaxed text-foreground/90">{item.quote}</p>

        {item.coach_note && (
          <p className="mt-4 rounded-md border-l-2 border-[hsl(var(--brand-red))] bg-muted/40 px-3 py-2 text-xs italic text-muted-foreground"><span className="font-semibold not-italic text-foreground">Coach: </span>{item.coach_note}</p>
        )}

        <div className="mt-4 flex items-center justify-between">
          {item.category && <span className="inline-flex items-center gap-1 text-xs font-semibold uppercase tracking-wide text-muted-foreground"><GraduationCap className="h-3.5 w-3.5 text-brand" />{item.category}</span>}
          {item.social_url && (
            <a href={item.social_url} target="_blank" rel="noopener noreferrer" data-testid="testimonial-social" className="inline-flex items-center gap-1 text-xs font-semibold uppercase tracking-wide text-brand hover:underline">Follow <ExternalLink className="h-3.5 w-3.5" /></a>
          )}
        </div>
      </div>
    </div>
  );
};
